import React from 'react';

const HolographicText = ({ 
  children, 
  variant = 'primary',
  size = 'base',
  glow = false,
  animate = false,
  className = '',
  ...props 
}) => {
  const variants = {
    primary: 'bg-gradient-to-r from-primary-600 via-primary-500 to-secondary-400',
    secondary: 'bg-gradient-to-r from-secondary-400 via-secondary-500 to-primary-500',
    cyber: 'bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600',
    neon: 'bg-gradient-to-r from-green-400 via-cyan-400 to-blue-500',
    rainbow: 'bg-gradient-to-r from-red-500 via-yellow-500 via-green-500 via-blue-500 to-purple-500'
  };

  const sizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '4xl': 'text-4xl',
    '5xl': 'text-5xl',
    '6xl': 'text-6xl'
  };

  const glowEffect = glow ? 'drop-shadow-lg' : '';
  const animateEffect = animate ? 'animate-hologram' : '';

  return (
    <span 
      className={`
        ${variants[variant]}
        ${sizes[size]}
        ${glowEffect}
        ${animateEffect}
        bg-clip-text text-transparent font-bold
        ${className}
      `}
      style={{
        backgroundSize: animate ? '200% 200%' : '100% 100%',
        filter: glow ? `drop-shadow(0 0 10px rgba(0,133,201,0.5))` : 'none'
      }}
      {...props}
    >
      {children}
    </span>
  );
};

export default HolographicText;
